export default __webpack_public_path__ + "static/media/hamburger.2b483b43.svg";